import { render, staticRenderFns } from "./mj4_25.vue?vue&type=template&id=db94e5a4&scoped=true"
import script from "./mj4_25.vue?vue&type=script&lang=js"
export * from "./mj4_25.vue?vue&type=script&lang=js"
import style0 from "./mj4_25.vue?vue&type=style&index=0&id=db94e5a4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db94e5a4",
  null
  
)

export default component.exports